import { CSSProperties } from "react";
import { IconStorage } from "@app/shared/icons/interfaces";
import { getStyle } from "@app/shared/icons/utils";

export const dragAndDropTexture: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <g style={getStyle(color, pathStyle)}>
      <circle cx="1.5" cy="1.5" r="1.5" />
      <circle cx="1.5" cy="6.5" r="1.5" />
      <circle cx="1.5" cy="11.5" r="1.5" />
      <circle cx="6.5" cy="1.5" r="1.5" />
      <circle cx="6.5" cy="6.5" r="1.5" />
      <circle cx="6.5" cy="11.5" r="1.5" />
    </g>
  ),
  svgProps: {
    height: "13",
    width: "8",
  }
};